/**
 * Reusable single "Activity Duration" minutes field for the last
 * FormStep of every completion content / typed encounter form (D5).
 *
 * Render path:
 *   1. The user logs minutes on the form's last step.
 *   2. The host component captures the minutes via state.
 *   3. On submit, the host calls `useTeeCareTimeForTask` (or the
 *      encounter-side variant) with the captured minutes + a
 *      surface-specific `method`.
 *
 * @agentic connections
 */

import { CareTimeInlineFields } from "./CareTimeInlineFields";

/** Props for `CareTimeActivityDurationField`. @agentic connections */
export type CareTimeActivityDurationFieldProps = {
  minutes: number | undefined;
  onMinutesChange: (value: number | undefined) => void;
  /** Override the default "Activity Duration" label (e.g. intake call). */
  label?: string;
  /** Override the default helper text. */
  helperText?: string;
};

/**
 * Single-input care-time field used at the bottom of every completion /
 * encounter form.
 * @agentic connections
 */
export const CareTimeActivityDurationField = ({
  minutes,
  onMinutesChange,
  label = "Activity Duration",
  helperText = "Time spent on this activity (optional)",
}: CareTimeActivityDurationFieldProps) => {
  return (
    <CareTimeInlineFields
      minutes={minutes}
      onMinutesChange={onMinutesChange}
      notes=""
      onNotesChange={() => {}}
      label={label}
      helperText={helperText}
      showNotes={false}
    />
  );
};
